import React from 'react';
import './DeviceStatusIndicator.scss';

export default class DeviceStatusIndicator extends React.PureComponent {


    render() {
        const props = this.props;
        return (
            <span className={`device-status-indicator ${props.device.isOnline ? "device-is-online": "device-is-offline"} ${props.large ? "large-box" : ""}`} >
                <p>{props.device.isOnline ? "ONLINE" : "Offline"}</p>
            </span>
        );
    }
    
}